import { render, staticRenderFns } from "./CopilotUserInsights.vue?vue&type=template&id=a86cafaa&"
import script from "./CopilotUserInsights.vue?vue&type=script&lang=js&"
export * from "./CopilotUserInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports